import { render, staticRenderFns } from "./BusinessPanel.vue?vue&type=template&id=4636b5eb&"
import script from "./BusinessPanel.vue?vue&type=script&lang=js&"
export * from "./BusinessPanel.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports